/**
 * WidgetFirstCard Component
 *
 * This component renders a card widget with a header and a list of items. Each item includes an image, title, and publish date.
 *
 * @param {Object} props - The properties passed to the component.
 * @param {string} props.headerTitle - The title for the widget header. This is required.
 * @param {string} [props.viewAllLink] - The URL for the "View All" link in the header.
 * @param {Array<Object>} props.data - An array of data objects to be displayed in the widget. Each object should follow the format:
 * {
 *   title: "",
 *   publishDate: "",
 *   image: {
 *     url: "",
 *     altText: ""
 *   }
 * }
 *
 * @returns {JSX.Element} The rendered WidgetFirstCard component.
 */

import PropTypes from 'prop-types'
import WidgetCardHeader from '../widgetHeader'
import styles from './style.module.scss'
import MyImage from '@shared/components/myImage'
// import Calendar from '@assets/images/placeholder/calendar.svg'
import { convertDt24h, dateCheck } from '@shared-submodule/utils'
import CustomLink from '@shared/components/customLink'

const WidgetFirstCard = ({ headerTitle, viewAllLink, data, viewAllInternalLink = false, cardInternalLink = false }) => {
  const renderCardItem = (item, idx) => (
    <div key={idx} className={styles.widget_card_item}>
      <div className={styles.widget_card_image}>
        <MyImage layout="fill" src={item?.image?.url} alt={item?.image?.altText || 'widget Image'} />
      </div>
      <div className={styles.widget_card_content}>
        <h3 className={styles.widget_card_title}>{item?.title}</h3>
        <p className={styles.widget_card_date}>
          {/* <MyImage src={Calendar} alt="Calendar Icon" height="18" width="18" /> */}
          {convertDt24h(dateCheck(item?.publishDate))}
        </p>
      </div>
    </div>
  )
  return (
    <div className={styles.widget_card}>
      <WidgetCardHeader headerText={headerTitle} link={viewAllLink} internalLink={viewAllInternalLink} />
      <div className={styles.widget_card_body}>
        {data &&
          data.map((item, idx) =>
            cardInternalLink ? (
              <CustomLink href={item?.sSlug || ''} key={item?.sSlug || idx}>
                <a>{renderCardItem(item, idx)}</a>
              </CustomLink>
            ) : (
              <a href={item?.sSlug || ''} key={item?.sSlug || idx}>
                {renderCardItem(item, idx)}
              </a>
            )
          )}
      </div>
    </div>
  )
}

WidgetFirstCard.propTypes = {
  headerTitle: PropTypes.string.isRequired,
  viewAllLink: PropTypes.string,
  data: PropTypes.arrayOf(PropTypes.object),
  viewAllInternalLink: PropTypes.bool,
  cardInternalLink: PropTypes.bool
}

export default WidgetFirstCard
